import { Injector, inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';

export const adminGuard: CanMatchFn = async (_route, segments): Promise<boolean | UrlTree> => {
  const injector = inject(Injector);
  const router = inject(Router);

  const { SnackbarService } = await import('@core/services/snackbar/snackbar.service');
  const snackBarService = injector.get(SnackbarService);
  const { AuthService } = await import('@core/services/auth/auth.service');
  const auth = injector.get(AuthService);
  const { TranslateService } = await import('@ngx-translate/core');
  const translateService = injector.get(TranslateService);

  await auth.ensureSessionFresh();

  // Not authenticated → redirect to login with returnUrl
  if (!auth.isAuthenticated()) {
    const returnUrl = `/${segments
      .map((s) => s.path)
      .filter(Boolean)
      .join('/')}`;
    return router.createUrlTree(['/'], {
      queryParams: returnUrl !== '/' ? { returnUrl } : undefined
    });
  }

  // Authenticated but not admin → sign out and redirect to login
  if (!auth.isAdmin()) {
    await auth.signOut();
    snackBarService.error(translateService.instant('error.insufficient_permissions'));
    return router.createUrlTree(['/']);
  }

  return true;
};
